import React from "react";
import { NavLink, useLocation } from "react-router-dom";

import side_help_support_icon from "../../assets/images/icons/sidebar/sidebar_help_support_icon.png";

function SidebarTW(props) {
  const location = useLocation();

  const { mode } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1
      ? " bg-black "
      : "  hover:bg-gray-200 hover:cursor-pointer text-black ";
  };

  return (
    <div className="  w-80  max-lg:hidden list-none  flex flex-col justify-between bg-[#f8f8f8]  border-r primary-border-color ">
      <ul className="text-white  pt-[1rem] ">
        {props.routes.map((prop, key) => {
          return (
            <>
              {!prop?.disable_sidebar && (
                <li
                  className={
                    activeRoute(prop.path) +
                    " mb-1 h-12  pl-[2.2rem]   font-raleway   "
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    key={key}
                    className="  flex flex-row gap-2 tracking-wider  items-center h-full mr-2   "
                  >
                    {prop.icon_element ? prop.icon_element : <></>}

                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              )}
            </>
          );
        })}
      </ul>
      {mode !== "admin" && (
        <ul>
          <li
            className={
              activeRoute("user/setting") +
              " mb-1 h-12 flex flex-col pl-[2.3rem]  justify-center font-raleway   "
            }
            key={"Help_and_support"}
          >
            <NavLink
              to={"help_and_support"}
              className="nav-NavLink  flex flex-row gap-2 nav-NavLink items-center h-full text-gray-600 "
              key={"Help_and_support"}
            >
              <img src={side_help_support_icon} className="w-6 h-6" />

              <p>{"Help & Support"}</p>
            </NavLink>
          </li>
        </ul>
      )}
    </div>
  );
}

export default SidebarTW;
